import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, Type } from '@angular/core';
import { ColumnsBlock } from '../../../model';

@Component({
  selector: 'dojo-columns-block-renderer',
  template: `
    <div
      class="columns-layout"
      [class.columns-3]="block().columns.length === 3"
      [class.show-borders]="block().show_borders"
    >
      @for (col of block().columns; track $index) {
        <div class="column">
          <ng-container *ngComponentOutlet="contentRenderer(); inputs: { blocks: col.content }" />
        </div>
      }
    </div>
  `,
  styles: `
    :host {
      display: block;
      container-type: inline-size;
    }

    .columns-layout {
      display: flex;
      flex-wrap: wrap;
      gap: 1rem;
      align-items: flex-start;
      justify-content: center;
    }

    .columns-layout > .column {
      flex: 1 1 0%;
      min-width: 0;
    }

    /* Vertical divider lines between columns */
    .columns-layout.show-borders > .column:not(:last-child) {
      border-right: 1px solid #d4d4d4;
    }

    /* 3-column intermediate: force third column to wrap below at full width */
    @container (max-width: 800px) {
      .columns-layout.columns-3 > .column {
        min-width: calc(50% - 0.5rem);
      }

      .columns-layout.columns-3.show-borders > .column:nth-child(2) {
        border-right: none;
      }
    }

    /* Narrow: stack all columns vertically */
    @container (max-width: 600px) {
      .columns-layout > .column,
      .columns-layout.columns-3 > .column {
        min-width: 100%;
      }

      .columns-layout.show-borders > .column:not(:last-child) {
        border-right: none;
        border-bottom: 1px solid #d4d4d4;
        padding-bottom: 1rem;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
})
export class ColumnsBlockRendererComponent {
  readonly block = input.required<ColumnsBlock>();
  readonly contentRenderer = input.required<Type<unknown>>();
}
